// src/telas/cadastro-tecnico/dados-basicos/index.tsx

import { RxDotFilled } from "react-icons/rx";
import styles from "../styles.module.css";
import { useContext, useRef } from "react";
import { FormularioContext } from "..";
import { ArquivosContext } from "../index";
import Swal from "sweetalert2";
import { MdDriveFolderUpload } from "react-icons/md";
import { FiTrash2 } from "react-icons/fi";
import { capitalizarPrimeiraLetraMaiusculaDeCadaPalavra, formatarCPFouCNPJ } from "../../../formatting/formatting";

export function DadosBasicos() {
  const contextForm = useContext(FormularioContext);
  const context = useContext(ArquivosContext);
  const uploadInputRef = useRef<any>();

  /* ── Upload ─────────────────────────────────────────────── */
  async function atualizarDocumentos(
    event: React.ChangeEvent<HTMLInputElement>,
  ) {
    Swal.fire({
      title: "Upload",
      html: "Carregando arquivos...",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    await new Promise((r) => setTimeout(r, 1000));

    if (event.target.files === null) {
      Swal.fire({ title: "Upload", html: "Erro ao carregar arquivos." });
      return;
    }

    let arquivos: any = [];

    for (let i = 0; i < event.target.files.length; i++) {
      await getBase64(event.target.files[i])
        .then((arquivo) => arquivos.push(arquivo))
        .catch(() => {
          Swal.fire({ title: "Upload", html: "Erro ao carregar arquivos." });
        });
    }

    context?.setDocumentos([...context.documentos, ...arquivos]);
    event.target.value = "";

    if (Swal.isLoading()) Swal.close();
  }

  function getBase64(
    file: any,
  ): Promise<{ file: string; name: string } | Error> {
    return new Promise((resolve, reject) => {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () =>
        resolve({ file: `${reader.result}`, name: file.name });
      reader.onerror = (error) => reject(error);
    });
  }

  function removerArquivo(index: number) {
    if (!context?.documentos) return;
    let aux = [...context.documentos];
    aux.splice(index, 1);
    context.setDocumentos(aux);
  }

  /* ── Formulário ─────────────────────────────────────────── */
  function atualizarFormulario(event: React.ChangeEvent<HTMLInputElement>) {
    let nome = event.target.name;
    let value = `${event.target.value}`;

    if (nome === "A2_CGC") {
      value = formatarCPFouCNPJ(value);

      contextForm?.setFormulario({
        ...contextForm.formulario,
        [nome]: value,
        A2_TIPO: value.length > 14 ? "J" : "F",
      });
    } else {
      contextForm?.setFormulario({
        ...contextForm.formulario,
        [nome]: value,
      });
    }
  }

  /* ── Render ─────────────────────────────────────────────── */
  return (
    <>
      {/* CPF / CNPJ */}
      <div className={styles.formGroup}>
        <div className={styles.groupInput}>
          <span>
            {!contextForm?.formulario.A2_CGC
              ? "CPF/CNPJ"
              : contextForm?.formulario.A2_CGC.length === 18
                ? "CNPJ"
                : contextForm?.formulario.A2_CGC.length === 14
                  ? "CPF"
                  : "CPF/CNPJ"}{" "}
            <RxDotFilled size={16} className={styles.legend} />
          </span>
          <input
            value={contextForm?.formulario.A2_CGC}
            type="text"
            name="A2_CGC"
            onChange={atualizarFormulario}
            placeholder="Digite seu CPF ou CNPJ"
            maxLength={18}
          />
          <label>Digite apenas números</label>
        </div>
      </div>

      {/* NOME */}
      <div className={styles.groupInput}>
        <span>
          Nome <RxDotFilled size={16} className={styles.legend} />
        </span>
        <input
          title="nome"
          maxLength={40}
          value={capitalizarPrimeiraLetraMaiusculaDeCadaPalavra(contextForm?.formulario.A2_NOME || "")}
          type="text"
          name="A2_NOME"
          onChange={atualizarFormulario}
          placeholder={
            contextForm?.formulario.A2_TIPO === "J"
              ? "Nome completo da empresa"
              : "Nome completo"
          }
          style={{ width: "100%" }}
        />
      </div>

      {/* NOME FANTASIA — apenas PJ */}
      {contextForm?.formulario.A2_TIPO === "J" && (
        <div className={styles.groupInput}>
          <span>
            Nome Fantasia <RxDotFilled size={16} className={styles.legend} />
          </span>
          <input
            title="nome_fantasia"
            value={capitalizarPrimeiraLetraMaiusculaDeCadaPalavra(contextForm?.formulario.A2_NREDUZ || "")}
            type="text"
            name="A2_NREDUZ"
            onChange={atualizarFormulario}
            placeholder="Nome fantasia da empresa"
            style={{ width: "100%" }}
          />
        </div>
      )}

      {/* INSCRIÇÕES — apenas PJ */}
      {contextForm?.formulario.A2_TIPO === "J" && (
        <div className={styles.formGroup}>
          <div className={styles.groupInput}>
            <span>Inscrição Estadual</span>
            <input
              title="inscricao_estadual"
              value={contextForm?.formulario.A2_INSCR}
              type="text"
              name="A2_INSCR"
              onChange={atualizarFormulario}
              placeholder=""
            />
            <label>Digite apenas números</label>
          </div>
          <div className={styles.groupInput}>
            <span>
              Inscrição Municipal{" "}
            </span>
            <input
              title="inscricao_municipal"
              value={contextForm?.formulario.A2_INSCRM}
              type="text"
              name="A2_INSCRM"
              onChange={atualizarFormulario}
              placeholder=""
            />
            <label>Digite apenas números</label>
          </div>
        </div>
      )}

      {/* SENHA */}
      <div className={styles.groupInput}>
        <span>
          Senha <RxDotFilled size={16} className={styles.legend} />
        </span>
        <input
          maxLength={20}
          value={contextForm?.formulario.A2_ZSENHA}
          type="password"
          name="A2_ZSENHA"
          onChange={atualizarFormulario}
          placeholder="Senha de acesso (mín. 6 caracteres)"
          style={{ width: "100%" }}
        />
      </div>

      {/* UPLOAD */}
      <div className={styles.uploadSection}>
        <span className={styles.uploadLabel}>
          Comprovante de Relação de Trabalho{" "}
          <RxDotFilled size={16} className={styles.legend} />
        </span>

        <div className={styles.uploadContainer}>
          <input
            ref={uploadInputRef}
            type="file"
            onChange={atualizarDocumentos}
            name="A2_ZOBSERV"
            placeholder="Documentos"
            multiple
            style={{ visibility: "hidden", height: 0 }}
          />
          <button
            className={styles.buttonUpload}
            onClick={() => uploadInputRef?.current?.click()}
          >
            <MdDriveFolderUpload size={18} /> Upload
          </button>

          {context?.documentos.map((doc, index) => (
            <div className={styles.fileRow} key={`${index}file`}>
              <h3>{doc.name}</h3>
              <button
                className={styles.removeFileButton}
                onClick={() => removerArquivo(index)}
              >
                <FiTrash2 size={14} /> Remover
              </button>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
